/* SLAYED BY SINA — global interactions */
(function () {
  'use strict';

  /* Nav pin on scroll */
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('pinned', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile drawer */
  var navT = document.getElementById('navT');
  var drw = document.getElementById('drawer');
  if (navT && drw) {
    navT.addEventListener('click', function () {
      var open = navT.getAttribute('aria-expanded') === 'true';
      navT.setAttribute('aria-expanded', String(!open));
      drw.hidden = open;
      drw.classList.toggle('open', !open);
      document.body.style.overflow = open ? '' : 'hidden';
    });
    drw.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        navT.setAttribute('aria-expanded', 'false');
        drw.hidden = true; drw.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drw.hidden) {
        navT.setAttribute('aria-expanded', 'false');
        drw.hidden = true; drw.classList.remove('open');
        document.body.style.overflow = ''; navT.focus();
      }
    });
  }

  /* Reveal: smooth cascade on load for what's already on screen,
     then scroll-triggered for everything below the fold. */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    requestAnimationFrame(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var i = 0;
      revealEls.forEach(function (el) {
        var top = el.getBoundingClientRect().top;
        if (top < vh * 0.92) {            // already visible on refresh → cascade
          var delay = i * 75;
          el.style.transitionDelay = delay + 'ms';
          el.classList.add('in');
          i++;
          // Clear the entrance delay after it plays so hovers stay instant.
          setTimeout(function () { el.style.transitionDelay = ''; }, delay + 850);
        }
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { if (!el.classList.contains('in')) io.observe(el); });
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* Stat count-up */
  function countUp(el, target, suffix, dur) {
    dur = dur || 1400;
    var isFloat = target % 1 !== 0, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var ease = 1 - Math.pow(1 - p, 3);
      el.textContent = (isFloat ? (ease * target).toFixed(1) : Math.round(ease * target)) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var stats = document.querySelectorAll('.stat');
  if ('IntersectionObserver' in window && stats.length) {
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var n = e.target.querySelector('[data-count]');
          if (n) countUp(n, parseFloat(n.dataset.count), n.dataset.suffix || '');
          so.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    stats.forEach(function (s) { so.observe(s); });
  }

  /* Product gallery thumbnails */
  var pdpMain = document.querySelector('[data-pdp-main]');
  if (pdpMain) {
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        pdpMain.src = t.getAttribute('data-full');
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* Shop carousel — Netflix-style horizontal row */
  document.querySelectorAll('[data-shop-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-shop-track]');
    var prev = car.querySelector('[data-shop-prev]');
    var next = car.querySelector('[data-shop-next]');
    if (!track) return;

    /* cards in a horizontal scroller can sit outside the vertical-reveal
       trigger, so reveal them all up front (hover effects still apply) */
    track.querySelectorAll('.card').forEach(function (c) { c.classList.add('in'); c.style.transitionDelay = ''; });

    /* cache layout-derived values; only recompute on resize (avoids per-frame reflow) */
    var maxScroll = 0, cardStep = 0;
    function measure() {
      maxScroll = track.scrollWidth - track.clientWidth - 1;
      var card = track.querySelector('.card');
      cardStep = card ? Math.max(card.getBoundingClientRect().width + 20, track.clientWidth * 0.85) : track.clientWidth * 0.8;
    }
    function update() { /* uses cached maxScroll — no layout read */
      var scrollable = maxScroll > 2;
      if (prev) prev.hidden = !scrollable || track.scrollLeft <= 2;
      if (next) next.hidden = !scrollable || track.scrollLeft >= maxScroll;
      car.toggleAttribute('data-at-start', track.scrollLeft <= 2);
      car.toggleAttribute('data-at-end', track.scrollLeft >= maxScroll);
    }
    measure();
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardStep, behavior: 'smooth' }); });
    var scrollScheduled = false;
    track.addEventListener('scroll', function () {
      if (scrollScheduled) return;
      scrollScheduled = true;
      window.requestAnimationFrame(function () { update(); scrollScheduled = false; });
    }, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); });

    /* drag / swipe to scroll (desktop pointer) */
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;       // native touch scroll handles it
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
      track.style.cursor = 'grabbing';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', function () { down = false; track.style.cursor = ''; });
    /* prevent a drag from triggering the card link click */
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    /* ── Continuous auto-slide (seamless conveyor) ── */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wantAuto = car.getAttribute('data-autoplay') !== 'false' && !reduceMotion;
    if (wantAuto && track.scrollWidth > track.clientWidth + 4) {
      var speed = parseFloat(car.getAttribute('data-speed')) || 0.5;
      // duplicate the set once so the loop is seamless
      var originals = Array.prototype.slice.call(track.children);
      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.classList.add('in');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.style.transitionDelay = '';
        track.appendChild(clone);
      });
      measure();
      var loopWidth = track.children[originals.length].offsetLeft - track.children[0].offsetLeft;
      var paused = false, offscreen = false;
      car.addEventListener('pointerenter', function () { paused = true; });
      car.addEventListener('pointerleave', function () { paused = false; });
      car.addEventListener('focusin', function () { paused = true; });
      car.addEventListener('focusout', function () { paused = false; });
      document.addEventListener('visibilitychange', function () { paused = document.hidden; });
      // pause the loop entirely when the carousel is scrolled off-screen (saves CPU)
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { offscreen = !e[0].isIntersecting; }, { threshold: 0 })
          .observe(car);
      }
      function tick() {
        if (!paused && !down && !offscreen) {       // pure transform-free scroll, no layout reads
          track.scrollLeft += speed;
          if (track.scrollLeft >= loopWidth) track.scrollLeft -= loopWidth;
        }
        window.requestAnimationFrame(tick);
      }
      window.requestAnimationFrame(tick);
    }

    update();
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.dataset.step === 'up' ? 1 : -1;
        var floor = parseInt(input.min || '1', 10);
        var v = Math.max(floor, (parseInt(input.value, 10) || floor) + step);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Cart: instant remove + quantity change via AJAX (form is the no-JS fallback) */
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function cartChange(key, qty, btn) {
    if (btn) { btn.disabled = true; btn.style.opacity = '0.5'; }
    fetch(cartRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; } });
  }
  document.querySelectorAll('[data-cart-remove]').forEach(function (b) {
    b.addEventListener('click', function () { cartChange(b.getAttribute('data-cart-remove'), 0, b); });
  });
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      cartChange(input.getAttribute('data-key'), q, null);
    });
  });
})();

/* ============================================================
   ✦ EXPERIENCE LAYER ✦
   loader · progress · cursor+sparkle · particles · 3D tilt
   · magnetic buttons · before/after · FAQ · sticky book
   ============================================================ */
(function () {
  'use strict';
  var noMotion = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var isCoarse = window.matchMedia('(pointer:coarse)').matches;

  // ── loader ──
  var loader = document.getElementById('loader');
  if (loader) {
    window.addEventListener('load', function () {
      setTimeout(function () {
        loader.classList.add('hide');
        loader.addEventListener('transitionend', function () { loader.remove(); }, { once: true });
      }, noMotion ? 0 : 420);
    });
  }

  // ── scroll progress bar ──
  var progressBar = document.getElementById('progress-bar');
  if (progressBar) {
    var prScheduled = false;
    window.addEventListener('scroll', function () {
      if (prScheduled) return;
      prScheduled = true;
      window.requestAnimationFrame(function () {
        var pct = Math.min(window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100, 100) || 0;
        progressBar.style.width = pct + '%';
        progressBar.setAttribute('aria-valuenow', Math.round(pct));
        prScheduled = false;
      });
    }, { passive: true });
  }

  // ── custom cursor + sparkle trail ──
  var cur = document.getElementById('cursor');
  var curRing = document.getElementById('cursor-ring');
  if (!isCoarse && cur && curRing && !noMotion) {
    document.body.classList.add('cursor-on');
    var mx = -200, my = -200, rx = -200, ry = -200;
    document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
    (function rafCursor() {
      cur.style.left = mx + 'px'; cur.style.top = my + 'px';
      rx += (mx - rx) * 0.13; ry += (my - ry) * 0.13;
      curRing.style.left = rx + 'px'; curRing.style.top = ry + 'px';
      window.requestAnimationFrame(rafCursor);
    })();
    var spkColors = ['rgba(196,80,106,', 'rgba(158,107,140,', 'rgba(201,136,112,'];
    var lastSpk = 0;
    document.addEventListener('mousemove', function (e) {
      var now = Date.now();
      if (now - lastSpk < 65) return;
      lastSpk = now;
      var sp = document.createElement('div');
      sp.className = 'sparkle';
      var size = 3 + Math.random() * 5;
      var col = spkColors[Math.floor(Math.random() * spkColors.length)];
      var dx = (Math.random() - 0.5) * 28, dy = (Math.random() - 0.5) * 28;
      sp.style.cssText = 'left:' + e.clientX + 'px;top:' + e.clientY + 'px;width:' + size + 'px;height:' + size + 'px;background:' + col + (0.55 + Math.random() * 0.35) + ');--dx:' + dx + 'px;--dy:' + dy + 'px;';
      document.body.appendChild(sp);
      setTimeout(function () { sp.remove(); }, 600);
    });
    document.querySelectorAll('a,button').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cur.classList.add('hov'); curRing.classList.add('hov'); });
      el.addEventListener('mouseleave', function () { cur.classList.remove('hov'); curRing.classList.remove('hov'); });
    });
  }

  // ── hero particles ──
  var pCont = document.getElementById('particles');
  if (pCont && !noMotion) {
    var pColors = ['rgba(196,80,106,', 'rgba(158,107,140,', 'rgba(201,136,112,', 'rgba(242,184,198,'];
    for (var i = 0; i < 20; i++) {
      var p = document.createElement('div');
      p.className = 'particle';
      var sz = 2 + Math.random() * 5;
      var c = pColors[Math.floor(Math.random() * pColors.length)];
      p.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + (Math.random() * 100) + '%;bottom:' + (Math.random() * 12) + '%;background:' + c + '1);--dur:' + (5 + Math.random() * 9) + 's;--delay:' + (-Math.random() * 12) + 's;--op:' + (0.18 + Math.random() * 0.32) + ';';
      pCont.appendChild(p);
    }
  }

  // ── 3D card tilt ──
  if (!isCoarse && !noMotion) {
    var addTilt = function (sel, intensity) {
      document.querySelectorAll(sel).forEach(function (card) {
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          card.style.transform = 'perspective(700px) rotateY(' + (x * intensity) + 'deg) rotateX(' + (-y * intensity) + 'deg) translateY(-5px)';
          card.style.boxShadow = 'var(--sh-lg)';
        });
        card.addEventListener('mouseleave', function () { card.style.transform = ''; card.style.boxShadow = ''; });
      });
    };
    addTilt('.srv', 9);
    addTilt('.rev', 7);
  }

  // ── magnetic primary buttons ──
  if (!isCoarse && !noMotion) {
    document.querySelectorAll('.btn-rose').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) * 0.28;
        var dy = (e.clientY - (r.top + r.height / 2)) * 0.28;
        btn.style.transform = 'translate(' + dx + 'px,' + dy + 'px) translateY(-2px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  // ── before / after slider ──
  var baSlider = document.getElementById('baSlider');
  var baAfter = document.getElementById('baAfter');
  var baDivider = document.getElementById('baDivider');
  if (baSlider && baAfter && baDivider) {
    var dragging = false;
    var setSlider = function (clientX) {
      var r = baSlider.getBoundingClientRect();
      var pct = Math.min(Math.max((clientX - r.left) / r.width, 0.03), 0.97);
      baAfter.style.clipPath = 'inset(0 ' + ((1 - pct) * 100) + '% 0 0)';
      baDivider.style.left = (pct * 100) + '%';
      baDivider.setAttribute('aria-valuenow', Math.round(pct * 100));
    };
    baDivider.addEventListener('mousedown', function (e) { dragging = true; e.preventDefault(); });
    document.addEventListener('mousemove', function (e) { if (dragging) setSlider(e.clientX); });
    document.addEventListener('mouseup', function () { dragging = false; });
    baDivider.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    document.addEventListener('touchmove', function (e) { if (dragging) setSlider(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('touchend', function () { dragging = false; });
    baDivider.addEventListener('keydown', function (e) {
      var r = baSlider.getBoundingClientRect();
      var c = parseFloat(baDivider.style.left || '50') / 100;
      if (e.key === 'ArrowLeft') { e.preventDefault(); setSlider(r.left + (c - 0.05) * r.width); }
      if (e.key === 'ArrowRight') { e.preventDefault(); setSlider(r.left + (c + 0.05) * r.width); }
    });
  }

  // ── FAQ accordion ──
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.hasAttribute('open');
      document.querySelectorAll('.faq-item[open]').forEach(function (o) {
        o.removeAttribute('open');
        o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) { item.setAttribute('open', ''); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  // ── sticky book button ──
  var stickyBook = document.getElementById('sticky-book');
  var heroEl = document.getElementById('hero');
  if (stickyBook && heroEl) {
    var checkSticky = function () { stickyBook.classList.toggle('vis', heroEl.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }
})();
